var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEconomic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5038 24H18.1886C17.5535 23.937 16.9549 23.6731 16.4799 23.2467C16.005 22.8203 15.6783 22.2536 15.5474 21.6289L11.5255 2.99004L7.3835 12.5946C7.26634 12.863 7.07319 13.0913 6.82786 13.2513C6.58253 13.4113 6.29574 13.496 6.00285 13.495H1.50071C1.1027 13.495 0.720986 13.3369 0.439548 13.0555C0.15811 12.774 0 12.3923 0 11.9943C0 11.5963 0.15811 11.2146 0.439548 10.9331C0.720986 10.6517 1.1027 10.4936 1.50071 10.4936H5.01238L8.77916 1.80448C9.03273 1.22139 9.46492 0.733898 10.0134 0.412281C10.5619 0.0906649 11.1984 -0.0484563 11.831 0.0149767C12.4637 0.0784096 13.0599 0.341119 13.5336 0.765227C14.0073 1.18934 14.3341 1.75293 14.4669 2.37475L18.4888 20.9986L22.6307 11.424C22.7433 11.15 22.9345 10.9154 23.1802 10.7498C23.4259 10.5842 23.7151 10.4951 24.0114 10.4936H28.5135C28.9115 10.4936 29.2932 10.6517 29.5747 10.9331C29.8561 11.2146 30.0142 11.5963 30.0142 11.9943C30.0142 12.3923 29.8561 12.774 29.5747 13.0555C29.2932 13.3369 28.9115 13.495 28.5135 13.495H25.0019L21.2351 22.1841C21.0051 22.7192 20.6244 23.1757 20.1394 23.4981C19.6544 23.8206 19.0861 23.9949 18.5038 24Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomic);
export default __webpack_public_path__ + "static/media/economic.1f14fedf5378c0ee4c20f232dfbf8066.svg";
export { ForwardRef as ReactComponent };